/* unplugin-vue-components disabled */import script from "./popup.vue?vue&type=script&setup=true&lang=js"
export * from "./popup.vue?vue&type=script&setup=true&lang=js"

import "./popup.vue?vue&type=style&index=0&id=7337fe3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7337fe3c"]])

export default __exports__